module.exports = __webpack_public_path__ + "static/media/dds.a3ecee72.png";